import React from 'react';

import { IconRight1 } from '@99designs/icons';
import { IconWrapper } from './IconWrapper';
import { BaseLinkProps } from './BaseLink';
import { getLinkColor, getLinkSize } from './helpers';
import { StyledCTALink } from './StyledCTALink';
import { typography } from '@99designs/ui/settings';

export type CTALinkProps = Omit<BaseLinkProps, 'size' | 'fontFamily'> & { icon?: React.ReactNode };

export function CTALink({ children, color = 'puntRoad', icon, ...props }: CTALinkProps) {
    const size = getLinkSize('jumbo');
    return (
        <StyledCTALink
            {...props}
            linkColor={getLinkColor(color)}
            size={size}
            linkFontFamily={typography.fontFamilies.heading}
        >
            {children}

            <IconWrapper size={size}>{icon ? icon : <IconRight1 />}</IconWrapper>
        </StyledCTALink>
    );
}
